<template>
  <div class="container-fluid subpage">
    <div class="text-center">
      <a class="back back--form" href="/"> Strona główna </a>
    </div>
    <h1
      v-if="loaderVisible"
      class="thanks__headline"
      v-html="content.data.pendingPage.intro"
    ></h1>
    <div v-if="loaderVisible" class="loading"></div>
    <div v-if="errorVisible" class="text-center py-5">
      <h3>
        <span v-html="content.data.pendingPage.error_0"></span>
        <br />
        <span v-html="content.data.pendingPage.error_1"></span>
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pending",
  data() {
    return {
      title: "Pending",
      loaderVisible: true,
      errorVisible: false,
    };
  },
  inject: ["content"],
  mounted() {
    setTimeout(() => {
      this.loaderVisible = false;
      this.errorVisible = true;
    }, 60000);
  },
};
</script>
